import Colors from 'assets/Colors';
import Styles from 'assets/Styles';
import UIConst from 'consts/UIConst';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import BaseInput from '../bases/BaseInput';
import BaseStaticModal from '../bases/BaseStaticModal';
import BaseText from '../bases/BaseText';
import SimpleInput from '../bases/SimpleInput';

export default class ModalEdit extends BaseStaticModal {
  static focus() {
    let scope = this.getScope();
    if (scope && scope.BaseInput) {
      scope.BaseInput.focus();
    }
  }

  reset = () => {
    this.BaseInput.reset();
  };

  onPressOk = () => {
    let { config } = this.state;
    const textInut = this.BaseInput.getText();
    const value = textInut?.length > 0 ? textInut : config?.text;
    if (config.callback) config.callback(value);
    if (config.autoClose !== false) ModalEdit.hide();
  };

  onPressCancel = () => {
    ModalEdit.hide();
  };

  renderContent = () => {
    const { config = {} } = this.state;
    let { placeholder = '', text, title = '', detail = '', multiline = true, isNumber, Header, maxLength, keyboardType, textAlign } = config;
    const InputComp = isNumber ? BaseInput : SimpleInput;
    textAlign = textAlign ? textAlign : !multiline ? 'center' : undefined;
    return (
      <View style={multiline ? styles.containerMultiline : styles.container}>
        {Header ? (
          <Header />
        ) : (
          <BaseText numberOfLines={1} style={styles.title}>
            {title}
          </BaseText>
        )}
        {detail ? <BaseText style={{ textAlign: 'center', marginHorizontal: UIConst.SCALE * 5 }}>{detail}</BaseText> : null}
        <InputComp
          textAlign={textAlign}
          ref={(ref) => (this.BaseInput = ref)}
          isNumber={!!isNumber}
          maxLength={maxLength}
          multiline={multiline}
          keyboardType={keyboardType}
          placeholder={placeholder}
          style={{ ...(multiline ? styles.inputMultiline : styles.input), backgroundColor: Colors.box }}
          defaultValue={text}
          autoFocus
        />
        {this.renderBottomButton()}
      </View>
    );
  };
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 10
  },
  containerMultiline: {
    paddingHorizontal: UIConst.SCALE * 10
  },
  title: {
    marginHorizontal: UIConst.SCALE * 10,
    textAlign: 'center',
    fontSize: UIConst.FONT_SIZE + 5,
    fontWeight: 'bold',
    marginVertical: 5
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 5
  },
  button: {
    margin: UIConst.SCALE * 5,
    borderRadius: UIConst.SCALE * 8,
    paddingHorizontal: UIConst.SCALE * 15,
    paddingVertical: UIConst.SCALE * 8,
    ...Styles.center,
    borderWidth: 1,
    borderColor: Colors.border
  },
  input: {
    ...Styles.border,
    margin: UIConst.SCALE * 5,
    marginBottom: UIConst.SCALE * 5,
    borderRadius: UIConst.SCALE * 5,
    paddingVertical: UIConst.SCALE * 3,
    width: '100%',
    height: UIConst.SCALE * 40
  },
  inputMultiline: {
    ...Styles.border,
    width: '100%',
    height: UIConst.SCALE * 150,
    margin: UIConst.SCALE * 5,
    marginBottom: UIConst.SCALE * 5,
    borderRadius: UIConst.SCALE * 5,
    textAlignVertical: 'top'
  }
});
